import * as d3 from "d3";
import IRiskMapData, { IRiskMap } from "../types/IRiskMapData";


export const generateRiskMap = (
  //svg: d3.Selection<SVGSVGElement, unknown, any, undefined>,
  svg: d3.Selection<SVGGElement, any, null, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  data: IRiskMap[],
  pitchWidth: number,
  pitchHeight: number,
) => {
  const RiskMapData = [
    {
      "locationX": 0,
      "locationY": 30.6,
      "count": 1
    },
    {
      "locationX": 0,
      "locationY": 44.2,
      "count": 1
    },
    {
      "locationX": 0,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 5.25,
      "locationY": 13.6,
      "count": 1
    },
    {
      "locationX": 5.25,
      "locationY": 27.2,
      "count": 1
    },
    {
      "locationX": 5.25,
      "locationY": 37.4,
      "count": 1
    },
    {
      "locationX": 5.25,
      "locationY": 40.8,
      "count": 1
    },
    {
      "locationX": 5.25,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 10.5,
      "locationY": 17,
      "count": 1
    },
    {
      "locationX": 10.5,
      "locationY": 54.4,
      "count": 1
    },
    {
      "locationX": 10.5,
      "locationY": 57.8,
      "count": 2
    },
    {
      "locationX": 10.5,
      "locationY": 68,
      "count": 1
    },
    {
      "locationX": 15.75,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 15.75,
      "locationY": 30.6,
      "count": 1
    },
    {
      "locationX": 15.75,
      "locationY": 34,
      "count": 1
    },
    {
      "locationX": 15.75,
      "locationY": 37.4,
      "count": 1
    },
    {
      "locationX": 15.75,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 15.75,
      "locationY": 51,
      "count": 2
    },
    {
      "locationX": 21,
      "locationY": 10.2,
      "count": 2
    },
    {
      "locationX": 21,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 21,
      "locationY": 23.8,
      "count": 2
    },
    {
      "locationX": 21,
      "locationY": 37.4,
      "count": 1
    },
    {
      "locationX": 21,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 26.25,
      "locationY": 3.4,
      "count": 2
    },
    {
      "locationX": 26.25,
      "locationY": 40.8,
      "count": 1
    },
    {
      "locationX": 26.25,
      "locationY": 47.6,
      "count": 2
    },
    {
      "locationX": 26.25,
      "locationY": 57.8,
      "count": 1
    },
    {
      "locationX": 26.25,
      "locationY": 64.6,
      "count": 1
    },
    {
      "locationX": 31.5,
      "locationY": 3.4,
      "count": 1
    },
    {
      "locationX": 31.5,
      "locationY": 13.6,
      "count": 1
    },
    {
      "locationX": 31.5,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 31.5,
      "locationY": 23.8,
      "count": 1
    },
    {
      "locationX": 31.5,
      "locationY": 30.6,
      "count": 2
    },
    {
      "locationX": 31.5,
      "locationY": 40.8,
      "count": 1
    },
    {
      "locationX": 31.5,
      "locationY": 57.8,
      "count": 1
    },
    {
      "locationX": 31.5,
      "locationY": 64.6,
      "count": 2
    },
    {
      "locationX": 31.5,
      "locationY": 68,
      "count": 3
    },
    {
      "locationX": 36.75,
      "locationY": 17,
      "count": 3
    },
    {
      "locationX": 36.75,
      "locationY": 23.8,
      "count": 1
    },
    {
      "locationX": 36.75,
      "locationY": 37.4,
      "count": 1
    },
    {
      "locationX": 36.75,
      "locationY": 44.2,
      "count": 1
    },
    {
      "locationX": 36.75,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 36.75,
      "locationY": 57.8,
      "count": 1
    },
    {
      "locationX": 36.75,
      "locationY": 61.2,
      "count": 2
    },
    {
      "locationX": 42,
      "locationY": 3.4,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 6.8,
      "count": 3
    },
    {
      "locationX": 42,
      "locationY": 13.6,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 17,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 20.4,
      "count": 2
    },
    {
      "locationX": 42,
      "locationY": 23.8,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 27.2,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 30.6,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 44.2,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 47.6,
      "count": 3
    },
    {
      "locationX": 42,
      "locationY": 51,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 54.4,
      "count": 1
    },
    {
      "locationX": 42,
      "locationY": 57.8,
      "count": 1
    },
    {
      "locationX": 47.25,
      "locationY": 3.4,
      "count": 1
    },
    {
      "locationX": 47.25,
      "locationY": 10.2,
      "count": 2
    },
    {
      "locationX": 47.25,
      "locationY": 34,
      "count": 1
    },
    {
      "locationX": 47.25,
      "locationY": 37.4,
      "count": 1
    },
    {
      "locationX": 47.25,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 47.25,
      "locationY": 51,
      "count": 1
    },
    {
      "locationX": 47.25,
      "locationY": 54.4,
      "count": 1
    },
    {
      "locationX": 47.25,
      "locationY": 57.8,
      "count": 4
    },
    {
      "locationX": 52.5,
      "locationY": 6.8,
      "count": 3
    },
    {
      "locationX": 52.5,
      "locationY": 13.6,
      "count": 1
    },
    {
      "locationX": 52.5,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 52.5,
      "locationY": 23.8,
      "count": 2
    },
    {
      "locationX": 52.5,
      "locationY": 27.2,
      "count": 1
    },
    {
      "locationX": 52.5,
      "locationY": 34,
      "count": 1
    },
    {
      "locationX": 52.5,
      "locationY": 40.8,
      "count": 2
    },
    {
      "locationX": 52.5,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 52.5,
      "locationY": 51,
      "count": 1
    },
    {
      "locationX": 52.5,
      "locationY": 57.8,
      "count": 1
    },
    {
      "locationX": 52.5,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 6.8,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 10.2,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 17,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 20.4,
      "count": 2
    },
    {
      "locationX": 57.75,
      "locationY": 27.2,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 30.6,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 37.4,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 40.8,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 44.2,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 51,
      "count": 2
    },
    {
      "locationX": 57.75,
      "locationY": 54.4,
      "count": 1
    },
    {
      "locationX": 57.75,
      "locationY": 61.2,
      "count": 2
    },
    {
      "locationX": 63,
      "locationY": 0,
      "count": 1
    },
    {
      "locationX": 63,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 63,
      "locationY": 27.2,
      "count": 1
    },
    {
      "locationX": 63,
      "locationY": 37.4,
      "count": 2
    },
    {
      "locationX": 63,
      "locationY": 44.2,
      "count": 1
    },
    {
      "locationX": 63,
      "locationY": 47.6,
      "count": 2
    },
    {
      "locationX": 63,
      "locationY": 64.6,
      "count": 2
    },
    {
      "locationX": 68.25,
      "locationY": 3.4,
      "count": 2
    },
    {
      "locationX": 68.25,
      "locationY": 6.8,
      "count": 2
    },
    {
      "locationX": 68.25,
      "locationY": 10.2,
      "count": 3
    },
    {
      "locationX": 68.25,
      "locationY": 13.6,
      "count": 2
    },
    {
      "locationX": 68.25,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 68.25,
      "locationY": 23.8,
      "count": 1
    },
    {
      "locationX": 68.25,
      "locationY": 27.2,
      "count": 1
    },
    {
      "locationX": 68.25,
      "locationY": 34,
      "count": 1
    },
    {
      "locationX": 68.25,
      "locationY": 44.2,
      "count": 2
    },
    {
      "locationX": 68.25,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 68.25,
      "locationY": 54.4,
      "count": 1
    },
    {
      "locationX": 68.25,
      "locationY": 57.8,
      "count": 1
    },
    {
      "locationX": 68.25,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 68.25,
      "locationY": 68,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 3.4,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 6.8,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 13.6,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 17,
      "count": 2
    },
    {
      "locationX": 73.5,
      "locationY": 23.8,
      "count": 2
    },
    {
      "locationX": 73.5,
      "locationY": 27.2,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 34,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 37.4,
      "count": 2
    },
    {
      "locationX": 73.5,
      "locationY": 40.8,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 44.2,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 51,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 73.5,
      "locationY": 64.6,
      "count": 3
    },
    {
      "locationX": 73.5,
      "locationY": 68,
      "count": 2
    },
    {
      "locationX": 78.75,
      "locationY": 6.8,
      "count": 2
    },
    {
      "locationX": 78.75,
      "locationY": 10.2,
      "count": 1
    },
    {
      "locationX": 78.75,
      "locationY": 17,
      "count": 1
    },
    {
      "locationX": 78.75,
      "locationY": 23.8,
      "count": 1
    },
    {
      "locationX": 78.75,
      "locationY": 30.6,
      "count": 3
    },
    {
      "locationX": 78.75,
      "locationY": 54.4,
      "count": 1
    },
    {
      "locationX": 78.75,
      "locationY": 57.8,
      "count": 1
    },
    {
      "locationX": 78.75,
      "locationY": 61.2,
      "count": 2
    },
    {
      "locationX": 78.75,
      "locationY": 64.6,
      "count": 1
    },
    {
      "locationX": 78.75,
      "locationY": 68,
      "count": 1
    },
    {
      "locationX": 84,
      "locationY": 6.8,
      "count": 1
    },
    {
      "locationX": 84,
      "locationY": 13.6,
      "count": 1
    },
    {
      "locationX": 84,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 84,
      "locationY": 27.2,
      "count": 1
    },
    {
      "locationX": 84,
      "locationY": 34,
      "count": 3
    },
    {
      "locationX": 84,
      "locationY": 47.6,
      "count": 3
    },
    {
      "locationX": 84,
      "locationY": 54.4,
      "count": 2
    },
    {
      "locationX": 84,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 84,
      "locationY": 64.6,
      "count": 2
    },
    {
      "locationX": 84,
      "locationY": 68,
      "count": 1
    },
    {
      "locationX": 89.25,
      "locationY": 17,
      "count": 1
    },
    {
      "locationX": 89.25,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 89.25,
      "locationY": 23.8,
      "count": 1
    },
    {
      "locationX": 89.25,
      "locationY": 34,
      "count": 1
    },
    {
      "locationX": 89.25,
      "locationY": 44.2,
      "count": 2
    },
    {
      "locationX": 89.25,
      "locationY": 47.6,
      "count": 2
    },
    {
      "locationX": 89.25,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 89.25,
      "locationY": 64.6,
      "count": 1
    },
    {
      "locationX": 89.25,
      "locationY": 68,
      "count": 2
    },
    {
      "locationX": 94.5,
      "locationY": 0,
      "count": 2
    },
    {
      "locationX": 94.5,
      "locationY": 10.2,
      "count": 3
    },
    {
      "locationX": 94.5,
      "locationY": 23.8,
      "count": 1
    },
    {
      "locationX": 94.5,
      "locationY": 30.6,
      "count": 2
    },
    {
      "locationX": 94.5,
      "locationY": 34,
      "count": 1
    },
    {
      "locationX": 94.5,
      "locationY": 37.4,
      "count": 1
    },
    {
      "locationX": 94.5,
      "locationY": 40.8,
      "count": 1
    },
    {
      "locationX": 94.5,
      "locationY": 44.2,
      "count": 2
    },
    {
      "locationX": 94.5,
      "locationY": 47.6,
      "count": 2
    },
    {
      "locationX": 94.5,
      "locationY": 51,
      "count": 2
    },
    {
      "locationX": 94.5,
      "locationY": 54.4,
      "count": 2
    },
    {
      "locationX": 94.5,
      "locationY": 57.8,
      "count": 2
    },
    {
      "locationX": 94.5,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 0,
      "count": 2
    },
    {
      "locationX": 99.75,
      "locationY": 6.8,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 17,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 20.4,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 34,
      "count": 3
    },
    {
      "locationX": 99.75,
      "locationY": 40.8,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 51,
      "count": 2
    },
    {
      "locationX": 99.75,
      "locationY": 54.4,
      "count": 2
    },
    {
      "locationX": 99.75,
      "locationY": 57.8,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 64.6,
      "count": 1
    },
    {
      "locationX": 99.75,
      "locationY": 68,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 0,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 3.4,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 6.8,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 23.8,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 27.2,
      "count": 2
    },
    {
      "locationX": 105,
      "locationY": 37.4,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 40.8,
      "count": 3
    },
    {
      "locationX": 105,
      "locationY": 47.6,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 51,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 54.4,
      "count": 2
    },
    {
      "locationX": 105,
      "locationY": 61.2,
      "count": 1
    },
    {
      "locationX": 105,
      "locationY": 68,
      "count": 2
    }
  ]
  // Calculate the minimum and maximum count values dynamically
  const minCount = d3.min(data, d => d.count) ?? 0; // Default to 0 if no data
  const maxCount = d3.max(data, d => d.count) ?? 1; // Default to 1 if no data
  const colorScale = d3.scaleLinear<string>()
    .domain([minCount, (minCount + maxCount) / 2, maxCount])
    .range(["green", "orange", "red"]) // Interpolate between red, orange, and green
    .interpolate(d3.interpolateHcl);

  svg.selectAll<SVGRectElement, IRiskMap>('rect')
    .data(data)
    .enter()
    .append('rect')
    .attr('x', d => xScale(d.locationX))
    .attr('y', d => yScale(d.locationY))
    .attr('width', xScale(5.25))
    .attr('height', yScale(3.4))
    .style('fill', (d: IRiskMap) => colorScale(d.count))
    .on("mouseover", function (event, d) {
      const index = data.indexOf(d);
      d3.select(`#text-${index}`).attr("opacity", 1);
    })
    .on("mouseout", function (event, d) {
      const index = data.indexOf(d);
      d3.select(`#text-${index}`).attr("opacity", 0);
    });


  svg.selectAll<SVGTextElement, IRiskMap>('text')
    .data(data)
    .enter()
    .append('text')
    .attr('id', (d, i) => `text-${i}`)
    .attr('x', d => xScale(d.locationX) + xScale(5.25) / 2)  // Position text horizontally centered in the rect
    .attr('y', d => yScale(d.locationY) + yScale(3.4) / 2)    // Position text vertically centered in the rect
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')
    .attr('font-size', '25px')
    .attr('font-weight', 'bolder')
    .attr('fill', 'white')
    .attr('opacity', 0) // Set opacity to 0 if you want it hidden initially
    .text(d => d.count);
};
